import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { equalisations as rules } from 'further-ui/validations';
import { z } from 'zod';

export type AddCommitmentsToEqualisationFormValues = z.infer<
  typeof rules.AddCommitmentsToEqualisationFormSchema
>;

type Props = {
  values: AddCommitmentsToEqualisationFormValues;
  children: React.ReactNode;
};

const FormWrapper: React.FC<Props> = ({ children, values }) => {
  const formMethods = useForm<AddCommitmentsToEqualisationFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.AddCommitmentsToEqualisationFormSchema),
    defaultValues: values,
    criteriaMode: 'all',
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
